<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="msmeDetailsForm" class="w-100">
      <div class="card mb-3">
        <div class="card-header"> <h2>Grievance Details by MSME</h2></div>
        <div class="card-body">
          <div class="row">
            <mat-label>Grievance ID : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="msmeGrievanceId">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Grievance Type : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="grievanceName">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Subject : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="subject">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Description : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="description">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Greivance Raised Date : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="createdDate">
            </mat-form-field>
          </div>
          <div class="row" *ngIf="!hideDownload">
            <div class="col-md-3">
              <mat-label>Document attached by MSME : </mat-label>
              <mat-card-content>
                <a style="cursor: pointer" class="btn btn-warning btn-sm mt-1"
                   (click)="onDownload()">
                  <i class="bi bi-download"></i> Download
                </a>
                <button class="btn btn-primary btn-sm mt-1 mx-1" (click)="openFilePreviewDialog()"> <i class="bi bi-eye"></i> View File</button>
              </mat-card-content>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="form" class="w-100">
      <div class="card mb-3">
        <div class="card-header"> <h2>Reply this Grievance</h2></div>
        <div class="card-body">
          <div class="row">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Reply</mat-label>
              <input matInput formControlName="reply" placeholder="Enter Reply" autocomplete="off" type="text">
              <mat-error>
                <div *ngIf="form.get('reply')?.errors?.['required'] && form.get('reply')?.touched" class="alert alert-danger">
                  Reply is required
                </div>
                <div *ngIf=" form.get('reply')?.errors?.['pattern']" class="alert alert-danger">
                  Reply is invalid
                </div>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status">
                <mat-option *ngFor="let status of statusList" [value]="status.id">{{ status.status }}</mat-option>
              </mat-select>
              <mat-error class="text-danger">
                <div *ngIf="form.get('status')?.errors?.['required'] && form.get('status')?.touched">
                  Please select status.
                </div>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row" *ngIf="!showDownloadBtn && !hideFileUpload">
            <div class="col-md-3">
              <mat-label>Attach supporting Document</mat-label>
              <mat-card-content>
                <input class="form-control"
                       type="file"
                       (change)="onGrievanceFileSelected($event)"
                       formControlName="documents"
                       accept=".jpg, .jpeg, .png, .pdf, .zip" />
              </mat-card-content>
            </div>
          </div>
          <div class="row" *ngIf="showDownloadBtn">
            <div class="col-md-3">
              <mat-label>Document attached by Reviewer : </mat-label>
              <mat-card-content>
                <a style="cursor: pointer"
                   class="btn btn-warning btn-sm mt-1"
                   (click)="onDownloadReply()">
                  <i class="bi bi-download"></i> Download
                </a>
                <button class="btn btn-primary btn-sm mx-1 mt-1" (click)="openReviewerFilePreviewDialog()"> <i class="bi bi-eye"></i> View File</button>
              </mat-card-content>
            </div>
          </div>
        </div>
      </div>

    </form>
    <div *ngIf="!hideFileUpload">
      <button type="submit" (click)="onSubmit()" class="btn btn-success">Submit</button>
      <button (click)="  OnReset()" class="btn btn-danger mx-2">Reset</button>
      <button (click)="onPressBack()" class="btn btn-info">Back</button>
    </div>
   
  </div>
</div>
<!--<div class="right-side p-5">
  <div class="section">
    
  </div>



</div>-->


